// import React, { useState } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// const DateAndTimePicker = ({
//   dateLabel,
//   timeLabel,
//   placeholderDate,
//   placeholderTime,
//   inputClassName = "",
//   isRequired = false,
//   showDate = true,
//   showTime = true,
//   selectedDate,
//   onDateChange,
// }) => {
//   const [selectedTime, setSelectedTime] = useState(null);
//   return (
//     <>
//       {/* Date Input */}
//       {showDate && (
//         <div>
//           {dateLabel && (
//             <label className="text-sm md:font-semibold font-medium text-gray-700 mb-1">
//               {dateLabel}
//               {isRequired && (
//                 <span className="text-red-500 ml-1 font-bold">*</span>
//               )}
//             </label>
//           )}
//           <DatePicker
//             selected={selectedDate}
//             onChange={(date) => onDateChange(date)}
//             dateFormat="MMMM d, yyyy"
//             className={`py-3 px-2 w-full text-sm border-2 border-gray-300 rounded-lg focus:outline-none !focus-visible:border-none focus:ring-0 focus:border-[#2BACE2] ${inputClassName}`}
//             placeholderText={placeholderDate}
//           />
//         </div>
//       )}

//       {/* Time Input */}
//       {showTime && (
//         <div>
//           {timeLabel && (
//             <label className="text-sm md:font-semibold font-medium text-gray-700 mb-1">
//               {timeLabel}
//               {isRequired && (
//                 <span className="text-red-500 ml-1 font-bold">*</span>
//               )}
//             </label>
//           )}
//           <DatePicker
//             selected={selectedTime}
//             onChange={(time) => setSelectedTime(time)}
//             showTimeSelect
//             showTimeSelectOnly
//             timeIntervals={15}
//             timeCaption="Time"
//             dateFormat="h:mm aa"
//             className={`py-3 px-2 w-full text-sm border-2 border-gray-300 rounded-lg focus:outline-none !focus-visible:border-none focus:ring-0 focus:border-[#2BACE2] ${inputClassName}`}
//             placeholderText={placeholderTime}
//           />
//         </div>
//       )}
//     </>
//   );
// };

// export default DateAndTimePicker;

import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateAndTimePicker = ({
  dateLabel,
  timeLabel,
  placeholderDate,
  placeholderTime,
  inputClassName = "",
  isRequired = false,
  showDate = true,
  showTime = true,
  selectedDate,
  onDateChange,
  minDate,
  setSelectedTime,
  selectedTime
}) => {
  // const [selectedTime, setSelectedTime] = useState(null);
  return (
    <>
      {/* Date Input */}
      {showDate && (
        <div>
          {dateLabel && (
            <label className="text-sm md:font-semibold font-medium text-gray-700 mb-1 ">
              {dateLabel}
              {isRequired && (
                <span className="text-red-500 ml-1 font-bold">*</span>
              )}
            </label>
          )}
          <DatePicker
            selected={selectedDate}
            onChange={(date) => onDateChange(date)}
            minDate={minDate ?? new Date()}
            dateFormat="MMMM d, yyyy"
            isClearable={selectedDate ? true : false}
            className={`py-3 px-2  w-full text-sm border-2 border-gray-300 rounded-lg focus:outline-none !focus-visible:border-none focus:ring-0 focus:border-[#2BACE2] ${inputClassName}`}
            placeholderText={placeholderDate}
          />
        </div>
      )}

      {/* Time Input */}
      {showTime && (
        <div>
          {timeLabel && (
            <label className="text-sm md:font-semibold font-medium text-gray-700 mb-1 ">
              {timeLabel}
              {isRequired && (
                <span className="text-red-500 ml-1 font-bold">*</span>
              )}
            </label>
          )}
          <DatePicker
            selected={selectedTime}
            onChange={setSelectedTime}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            timeCaption="Time"
            dateFormat="h:mm aa"
            className={`py-3 px-2 w-full text-sm border-2 border-gray-300 rounded-lg focus:outline-none !focus-visible:border-none focus:ring-0 focus:border-[#2BACE2] ${inputClassName}`}
            placeholderText={placeholderTime}
          />
        </div>
      )}
    </>
  );
};

export default DateAndTimePicker;
